import { EmailProviderFields } from '../../../api';

export enum EmailProviders {
  send_grid = 'send_grid',
  smtp = 'smtp'
}

export type FormValues = {
  provider_type: Partial<Record<EmailProviders, boolean>>;
  custom_email: string;
  from_email_name: string;
  provider_settings: EmailProviderFields;
};

export type ValidationError = Record<keyof Omit<FormValues, 'provider_type'>, string>;

export type ValidationErrorObject = Record<keyof EmailProviderFields, string>;

export type FieldsProps = {
  errors: ValidationError;
  projectName?: string;
};

export type ProviderFieldsProps = {
  errors: ValidationErrorObject;
};
